const columnsColspan = {
  ALERTS_COLUMN: 1,
  SELECT_ALL_COLUMN: 1,
  EMPLOYEE_COLUMN: 2,
  ESTIMATED_HOURS_COLUMN: 1,
  WORKED_HOURS_COLUMN: 1,
  DISTRIBUTION_COLUMN: 2,
  HOUR_BALANCE_COLUMN: 1,
  NAVIGATION_ICON_COLUMN: 1,
}

export type colsKeyType = keyof typeof columnsColspan

type columnsType = {
  [key in colsKeyType]: number
}

export const getColumnsColspan = (): columnsType => columnsColspan
